var React = require('react');

function Tag (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"tag-fill","transform":"translate(-2.25 -2.25)","opacity":"0.3"},React.createElement("path",{"id":"パス_50","data-name":"パス 50","d":"M3.354,2.25a1.1,1.1,0,0,0-1.1,1.1V8.418a1.1,1.1,0,0,0,.323.781L10.3,16.927a1.1,1.1,0,0,0,1.561,0l5.064-5.064a1.1,1.1,0,0,0,0-1.561L9.2,2.574a1.1,1.1,0,0,0-.78-.324ZM7.77,6.114A1.656,1.656,0,1,1,6.114,4.458,1.656,1.656,0,0,1,7.77,6.114Z","transform":"translate(0)","fillRule":"evenodd"})));
}

Tag.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 15 15","stroke":"currentcolor","fill":"currentcolor","strokeWidth":"0"};

module.exports = Tag;

Tag.default = Tag;
